import { useState } from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { LoadingSpinner } from '@/components/common/LoadingSpinner'
import { ErrorMessage } from '@/components/common/ErrorMessage'
import { AlertCard } from '@/components/alert/AlertCard'
import { useTriggeredAlerts } from '@/hooks/useAlerts'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

export const AlertHistoryPage = () => {
  const [showDismissed, setShowDismissed] = useState(false)
  const { data, isLoading, error } = useTriggeredAlerts(showDismissed)

  if (error) {
    return <ErrorMessage message="Failed to load alert history. Please try again." />
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold">Alert History</h1>
      </div>

      <Tabs value={showDismissed ? 'dismissed' : 'active'} onValueChange={(v) => setShowDismissed(v === 'dismissed')}>
        <TabsList>
          <TabsTrigger value="active">Active Alerts</TabsTrigger>
          <TabsTrigger value="dismissed">Dismissed Alerts</TabsTrigger>
        </TabsList>

        <TabsContent value="active" className="space-y-4 mt-6">
          {isLoading ? (
            <LoadingSpinner />
          ) : data && data.alerts.length > 0 ? (
            data.alerts.map((alert) => <AlertCard key={alert.id} alert={alert} />)
          ) : (
            <Card>
              <CardContent className="py-8">
                <p className="text-center text-muted-foreground">No active alerts</p>
              </CardContent>
            </Card>
          )}
        </TabsContent>

        <TabsContent value="dismissed" className="space-y-4 mt-6">
          {isLoading ? (
            <LoadingSpinner />
          ) : data && data.alerts.length > 0 ? (
            data.alerts.map((alert) => <AlertCard key={alert.id} alert={alert} />)
          ) : (
            <Card>
              <CardContent className="py-8">
                <p className="text-center text-muted-foreground">No dismissed alerts</p>
              </CardContent>
            </Card>
          )}
        </TabsContent>
      </Tabs>
    </div>
  )
}
